import React from "react";

const Button = passedProps => {
  let { className, children, ...props } = passedProps;

  className = `btn ${className}`;
  return (
    <button className={className} {...props}>
      {children}
    </button>
  );
};

export default Button;
